import { Tile, LetterState } from '../types/game';

// Türkçe karakter normalizasyonu
export const normalizeTurkishText = (text: string): string => {
    return text
        .replace(/ı/g, 'I')
        .replace(/i/g, 'İ')
        .replace(/ğ/g, 'Ğ')
        .replace(/ü/g, 'Ü')
        .replace(/ş/g, 'Ş')
        .replace(/ö/g, 'Ö')
        .replace(/ç/g, 'Ç')
        .toUpperCase();
};

// Kelimeler listesi - JSON dosyasından yüklenecek
let TURKISH_WORDS: { [length: number]: string[] } = {};

// JSON dosyasından kelimeleri yükle
export const loadWords = async (wordLength?: number): Promise<string[]> => {
    // Eğer belirli bir uzunluk isteniyorsa ve o uzunluk zaten yüklenmişse, onu döndür
    if (wordLength && TURKISH_WORDS[wordLength]) {
        return TURKISH_WORDS[wordLength];
    }

    // Eğer tüm kelimeler yüklenmemişse, yükle
    if (Object.keys(TURKISH_WORDS).length === 0) {
        try {
            const response = await fetch('/kelimeler.json');
            const words = await response.json();

            // Tüm uzunluklardaki kelimeleri grupla
            for (let length = 4; length <= 8; length++) {
                TURKISH_WORDS[length] = words
                    .filter((word: string) => word.length === length)
                    .map((word: string) => normalizeTurkishText(word))
                    .filter((word: string) => /^[A-ZÇĞIİÖŞÜ]+$/.test(word));

                console.log(`${length} harfli ${TURKISH_WORDS[length].length} kelime yüklendi`);
            }

        } catch (error) {
            console.error('Kelimeler yüklenirken hata:', error);
            // Fallback olarak eski listeyi kullan
            TURKISH_WORDS[5] = [
                'AKICI', 'BALIK', 'CEMRE', 'DENIZ', 'ELMAS', 'FENER', 'GÜLME', 'HIZLI',
                'İNCE', 'JETON', 'KALEM', 'LİMON', 'MAKAS', 'NARIN', 'OKUL', 'PAPATYA',
                'RÜZGAR', 'SABUN', 'TARAK', 'UÇAK', 'VİDEO', 'YAPRAK', 'ZEYTİN'
            ].map(word => normalizeTurkishText(word));
        }
    }

    // Eğer belirli bir uzunluk isteniyorsa, onu döndür
    if (wordLength) {
        return TURKISH_WORDS[wordLength] || [];
    }

    // Varsayılan olarak 5 harfli kelimeleri döndür
    return TURKISH_WORDS[5] || [];
};

export const generateRandomWord = async (wordLength: number = 5): Promise<string> => {
    const words = await loadWords(wordLength);
    return words[Math.floor(Math.random() * words.length)];
};

export const generateRoomCode = (): string => {
    return Math.random().toString(36).substring(2, 8).toUpperCase();
};

export const validateGuess = (guess: string, targetWord: string): Tile[] => {
    const tiles: Tile[] = [];
    const targetLetters = targetWord.split('');
    const guessLetters = guess.split('');

    // Önce doğru pozisyonları bul
    const correctPositions = new Set<number>();
    const remainingTargetLetters = [...targetLetters];
    const remainingGuessLetters = [...guessLetters];

    // Doğru pozisyonları işaretle
    for (let i = 0; i < guessLetters.length; i++) {
        if (guessLetters[i] === targetLetters[i]) {
            correctPositions.add(i);
            remainingTargetLetters[i] = '';
            remainingGuessLetters[i] = '';
        }
    }

    // Kalan harfleri kontrol et
    for (let i = 0; i < guessLetters.length; i++) {
        if (correctPositions.has(i)) {
            tiles.push({ letter: guessLetters[i], state: 'correct' });
        } else if (remainingGuessLetters[i] !== '') {
            const letterIndex = remainingTargetLetters.indexOf(remainingGuessLetters[i]);
            if (letterIndex !== -1) {
                tiles.push({ letter: remainingGuessLetters[i], state: 'present' });
                remainingTargetLetters[letterIndex] = '';
            } else {
                tiles.push({ letter: remainingGuessLetters[i], state: 'absent' });
            }
        } else {
            tiles.push({ letter: '', state: 'empty' });
        }
    }

    return tiles;
};

export const isWordValid = async (word: string, wordLength?: number): Promise<boolean> => {
    const targetLength = wordLength || word.length;
    const words = await loadWords(targetLength);
    const normalizedWord = normalizeTurkishText(word);
    return word.length === targetLength && /^[A-ZÇĞIİÖŞÜ]+$/.test(normalizedWord) && words.includes(normalizedWord);
};

export const getKeyboardState = (guesses: Tile[][]): Record<string, LetterState> => {
    const keyboardState: Record<string, LetterState> = {};

    guesses.forEach(guess => {
        guess.forEach(tile => {
            if (tile.letter && tile.state !== 'empty') {
                const currentState = keyboardState[tile.letter];
                if (!currentState || tile.state === 'correct' ||
                    (tile.state === 'present' && currentState === 'absent')) {
                    keyboardState[tile.letter] = tile.state;
                }
            }
        });
    });

    return keyboardState;
};
